import React from 'react';
import Icon from '../../../components/AppIcon';

const TypingIndicator = () => {
  return (
    <div className="flex justify-end mb-4">
      <div className="max-w-xs sm:max-w-md lg:max-w-lg order-1">
        <div className="px-4 py-3 bg-primary/20 text-primary rounded-2xl rounded-bl-md shadow-subtle animate-pulse">
          <div className="flex items-center space-x-reverse space-x-2">
            <div className="flex space-x-reverse space-x-1">
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            </div>
            <span className="text-sm text-primary">در حال تایپ...</span>
          </div>
        </div>
      </div>

      <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 order-2 mr-3 bg-primary">
        <Icon name="Scale" size={16} color="white" />
      </div>
    </div>
  );
};

export default TypingIndicator;